// @flow

//
// React
//
import React, { useState } from 'react';

//
// Material UI
//
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Modal from '@mui/material/Modal';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import DeleteIcon from "@mui/icons-material/Delete";

import Image from 'mui-image';

//
// Formatter
//
import {
    fmtQuantity,
    fmtMoney
} from '../../../../../lib/trix-web-data-commons';

//
// Component
//
const createRetailSaleLineTableCellRenderer = (cfg: any): any => (props: any): any => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);
    const handleMenuOpen = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const [openImageDialog, setOpenImageDialog] = useState(false);
    const handleOpenImageDialog = () => setOpenImageDialog(true);
    const handleCloseImageDialog = () => setOpenImageDialog(false);

    const row = (props.row) ? props.row : {};

    const stock = (row && row.stock) ? row.stock : {}
    const sku = (stock.sku) ? stock.sku : (stock.barcode) ? stock.barcode : '';
    const name = (stock.name && stock.name.bg) ? stock.name.bg : (stock.name.en) ? stock.name.en : '';

    // PATCH: 
    const imageUrl = `https://trix.tendenz.bg/rp/${sku.substring(0, sku.length - 2)}_1.jpg`;
    // const imageUrl = 'https://img.tendenz.bg/2d0f648eb7b42b1bc5e429268d58b9dd0137269.jpg';

    const quantity = row.quantity;

    const discountPercent = props.row.discountPercent;
    const unitPrice = props.row.unitPrice;
    const totalAmount = props.row.totalAmount;

    const handleDeleteItem = () => {
        let action = null;
        for (let n in cfg.__halFormsTemplate.actions) {
            if (cfg.__halFormsTemplate.actions[n].name === 'onDeleteItem') {
                action = cfg.__halFormsTemplate.actions[n];
                break;
            }
        }
        if (action) {
            cfg.__halFormsActionExtender.executeHalFormsAction(
                action, props.row, cfg.container, {});
        }

        return;
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'stretch',
                    paddingTop: 1,
                    paddingBottom: 1,
                    gap: 2,
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        flex: '0 0 auto',
                        width: '100px',
                    }}
                >
                    <Image
                        src={imageUrl}
                        style={{ cursor: 'pointer', borderRadius: 8 }}
                        onClick={handleOpenImageDialog}
                        showLoading
                    />
                </Box>

                <Box 
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        minWidth: '100px',
                        wordBreak: 'break-word',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Typography variant='subtitle2' display='block' sx={{ flexGrow: 1 }}>
                            {sku}
                        </Typography>

                        <div>
                            <IconButton
                                size='small'
                                onClick={handleMenuOpen}
                            >
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={menuOpen}
                                onClose={handleMenuClose}
                            >
                                <MenuItem 
                                    onClick={handleDeleteItem}
                                >
                                    Изтрии
                                </MenuItem>
                            </Menu>
                        </div>
                    </Box>
                    <Typography variant='caption' display='block'>
                        {name}
                    </Typography>
                    
                    <Stack 
                        direction='row' 
                        spacing={2} 
                        sx={{
                            flexGrow: 1, 
                            display: 'flex',
                            alignItems: 'flex-end',
                        }}
                    >
                        <Stack sx={{ display: 'flex', alignItems: 'left', gap: 0.5, mt: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                                {fmtQuantity(quantity)}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                x {fmtMoney(unitPrice)}
                            </Typography>
                        </Stack>
                        <Box sx={{ 
                            flexGrow: 1, 
                            position: "relative",
                        }}>
                            <Typography 
                                variant='subtitle1' 
                                color='text.secondary'
                                sx={{ textAlign: 'right', width: '100%' }}
                            >
                                {fmtMoney(totalAmount)}
                            </Typography>
                        </Box>
                    </Stack>
                </Box>
            </Box>

            {/* Image modal */}
            <Modal open={openImageDialog} onClose={handleCloseImageDialog}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                    <Image
                        src={imageUrl}
                        fit='contain'
                        style={{ maxWidth: '100%', maxHeight: '80vh' }}
                    />
                </Box>
            </Modal>
        </>
    );
}

const createRetailSaleLineTableColumn = (cfg: any): any => { 
    return {
        flex: true,
        width: 100,

        renderCell: createRetailSaleLineTableCellRenderer({
            ...cfg.cellRendererFactoryProps,
        })
    }
};
export default createRetailSaleLineTableColumn;
